import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useDeleteNotificationMutation,
  useGetNotificationsMutation,
  useReadNotificationMutation,
} from "../../services/Post";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import InfiniteScroll from "react-infinite-scroll-component";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Link, useNavigate } from "react-router-dom";
import { setIds } from "../../app/slices/localSlice";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import { getLanguage } from "../../javascript/SelectLanguage";

dayjs.extend(relativeTime);

export default function Notification() {
  const userToken = useSelector((data) => data?.local?.token);
  const [MyNotification] = useGetNotificationsMutation();
  const [readNotification] = useReadNotificationMutation();
  const [loadingStatesdel, setLoadingStatesdel] = useState({});
  const [
    deleteNotification,
    { isLoading: loadersss },
  ] = useDeleteNotificationMutation();
  const [notificationList, setNotificationList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const accountType = useSelector((state) => state?.local?.accountType);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleNotification = async (currentPage = 1, isLoadMore = false) => {
    const res = await MyNotification({
      userToken,
      search: "",
      page: currentPage,
      pageSize: 5,
      language: getLanguage(),
    });

    if (res?.data?.error || res?.error?.data?.error) {
      if (res?.error?.data?.error_code === 401) {
        navigate("/login");
      }
      toast.error(res?.data?.message || res?.error?.data?.message);
    } else {
      setNotificationList((prev) =>
        isLoadMore
          ? [...prev, ...(res?.data?.results?.notifications || [])]
          : res?.data?.results?.notifications || []
      );
      setTotalResults(res?.data?.results?.total || 0);
    }
  };

  useEffect(() => {
    if (userToken) {
      handleNotification();
    }
  }, [userToken]);

  const fetchMoreData = () => {
    if (notificationList.length < totalResults) {
      setPage((prevPage) => {
        const nextPage = prevPage + 1;
        handleNotification(nextPage, true);
        return nextPage;
      });
    }
  };

  const groupNotificationsByDate = (notifications) => {
    const grouped = {};
    notifications.forEach((notif) => {
      const date = dayjs(notif.createdAt).format("YYYY-MM-DD");
      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(notif);
    });
    return grouped;
  };

  const formatDateLabel = (date) => {
    if (dayjs(date).isSame(dayjs(), "day")) return "Today";
    if (dayjs(date).isSame(dayjs().subtract(1, "day"), "day"))
      return "Yesterday";
    return dayjs(date).format("DD MMM YYYY");
  };

  const groupedNotifications = groupNotificationsByDate(notificationList);

  const markAsRead = async (id, type) => {
    try {
      Swal.fire({
        title: t("Please wait..."),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await readNotification({ userToken, id });

      Swal.close();

      if (res?.data?.error || res?.error?.data?.error) {
        toast.error(res?.data?.message || res?.error?.data?.message);
      } else {
        handleNotification();

        if (accountType === "Buyer") {
          switch (type) {
            case "ORDER_PLACED":
              navigate("/my-order");
              break;
            case "SAMPLE_ORDER":
              navigate("/my-order");
              break;
            case "QUOTE_ORDER":
              navigate("/my-quote");
              break;
            case "BUYER_PAYMENT_COMPLETED":
              navigate("/my-earning");
              break;
            case "BUYER_PAYMENT_APPROVED":
              navigate("/my-earning");
              break;
            case "PAYMENT_INVOICE":
              navigate("/my-order");
              break;
            default:
              break;
          }
        } else if (accountType === "Seller") {
          switch (type) {
            case "SELLER_ORDER_PLACED":
              navigate("/my-order");
              break;
            case "SELLER_SAMPLE_ORDER":
              navigate("/my-order");
              break;
            case "SELLER_QUOTE_ORDER":
              navigate("/my-order");
              break;
            case "SELLER_ACCEPTED":
              navigate("/my-order");
              break;
            case "SELLER_PAYMENT_APPROVED":
              navigate("/my-order");
              break;
            case "DRIVER_ACCEPTED_ORDER":
              navigate("/seller-orders");
              break;
            default:
              break;
          }
        }
      }
    } catch (error) {
      Swal.close();
      toast.error("Something went wrong while marking as read");
      console.error(error);
    }
  };

  const handleDelUser = async (id, index) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#764AE7",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Yes, delete it!"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: t("Deleting..."),
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          setLoadingStatesdel((prevState) => ({ ...prevState, [index]: true }));
          const res = await deleteNotification({ id, userToken });
          setLoadingStatesdel((prevState) => ({
            ...prevState,
            [index]: false,
          }));

          Swal.close();

          if (res?.data?.error || res?.error?.data?.error) {
            toast.error(res?.data?.message || res?.error?.data?.message);
          } else {
            toast.success(res?.data?.message);
            handleNotification();
          }
        } catch (error) {
          Swal.close();
          toast.error(t("An error occurred while deleting the user."));
        } finally {
          setLoadingStatesdel((prevState) => ({
            ...prevState,
            [index]: false,
          }));
        }
      }
    });
  };

  const unreadCount =
    notificationList?.filter((ite) => !ite?.isRead).length || 0;

  return (
    <div className="col-auto px-0 icon-header">
      <div className="dropdown notification-dropdown">
        <button
          className="bg-transparent border-0"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img
            src="/assets/img/resources/notification.svg"
            alt="Notifications"
          />
          {unreadCount > 0 && (
            <span
              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
              style={{ fontSize: "12px", padding: "5px 8px" }}
            >
              {unreadCount}
            </span>
          )}
        </button>
        <ul className="dropdown-menu card ">
          <div className="d-flex align-items-center justify-content-between card-header bg-white border-bottom">
            <h2 className="fs-20 fw-semibold">{t("Recent Notifications")}</h2>
            <div
              className="ps-4"
              onClick={() => (loadersss ? "" : handleDelUser())}
              style={{ display: notificationList?.length > 0 ? "" : "none" }}
            >
              {loadersss ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="sr-only">
                    <Spinner />
                  </span>
                </div>
              ) : (
                <i className="fa fa-trash text-danger"></i>
              )}
            </div>
          </div>
          <div
            className="card-body notification-dropdown-menue"
            id="scrollableDiv"
          >
            <InfiniteScroll
              dataLength={notificationList?.length}
              next={fetchMoreData}
              hasMore={notificationList?.length < totalResults}
              loader={<Skeleton height={80} width={"90vh"} className="mb-2" />}
              scrollableTarget="scrollableDiv"
            >
              {notificationList?.length > 0 ? (
                Object.keys(groupedNotifications).map((date) => (
                  <div key={date}>
                    <p className="text-dark fw-bold fs-16">
                      {formatDateLabel(date)}
                    </p>
                    {groupedNotifications[date]?.map((notif, ind) => (
                      <Link
                        to="#"
                        key={notif._id}
                        className={`d-flex border-bottom mb-3 user-noti-wrapper px-0 ${
                          notif.isRead
                            ? "read-notification"
                            : "unread-notification"
                        }`}
                        onClick={() => markAsRead(notif._id, notif?.type)}
                      >
                        <div className="d-flex gap-2 w-100 px-2">
                          <div className="user-2 flex-auto">
                            <img
                              src="/assets/img/icon/big-user.png"
                              alt="User"
                            />
                          </div>
                          <div className="flex-grow-1 w-100">
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <p className="m-0 flex-auto fw-semibold fs-16">
                                {i18n.language === "ar"
                                  ? notif?.title_ar
                                  : i18n.language === "bn"
                                  ? notif?.title_bn
                                  : notif?.title_en}
                              </p>
                              <p className="m-0 flex-auto text-muted fs-14 text-end">
                                {dayjs(notif.createdAt).fromNow()}
                              </p>
                            </div>
                            <p
                              className="text-secondary fs-14"
                              style={{ wordBreak: "break-all" }}
                            >
                              {i18n.language === "ar"
                                ? notif?.body_ar
                                : i18n.language === "bn"
                                ? notif?.body_bn
                                : notif?.body_en}
                            </p>
                          </div>
                          <div
                            className="ps-4 d-none"
                            onClick={() => handleDelUser(notif?._id, ind)}
                          >
                            {loadingStatesdel[ind] ? (
                              <div
                                className="spinner-border spinner-border-sm"
                                role="status"
                              >
                                <span className="sr-only">
                                  <Spinner />
                                </span>
                              </div>
                            ) : (
                              <i className="fa fa-trash text-danger" />
                            )}
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                ))
              ) : (
                <p className="text-center text-muted">
                  {t("No Notifications Available")}
                </p>
              )}
            </InfiniteScroll>
          </div>
        </ul>
      </div>
    </div>
  );
}
